import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {Observable} from "rxjs";
import { HttpClient } from '@angular/common/http';
import {PossibleResolutionDialogComponent} from "./possible-resolution-dialog.component";
import {cloneDeep} from "lodash";


@Component({
  templateUrl: "./error-more-details-dialog.template.pug",
  providers: [
    
  ],
})
export class ErrorMoreDialogComponent extends DialogComponent<void, boolean> {
  public detail: any;
  private possibleResolutionDetail:any;
  static errorData = {};
  public isMultipleErrorCode:boolean = false;
  static showCreateDialog(dialogService: DialogService,data:any): Observable<boolean> {
    this.errorData = data;
    
    return dialogService.addDialog(ErrorMoreDialogComponent, undefined, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }



 

  cancel(): void {
    this.result = false;
    this.close();
  }

  public openDialog(item): void {
   let messageObj =  item.message.split('|| errorSummary:');
   let errorSummaryObj = {'errorCode':''}
   if(messageObj.length && messageObj[1] ){
    errorSummaryObj = JSON.parse(messageObj[1])['Details'];
   }
    PossibleResolutionDialogComponent.showCreateDialog(this.dialogService,errorSummaryObj);
  }

  async ngOnInit() {
    this.detail = cloneDeep(ErrorMoreDialogComponent.errorData);
    this.possibleResolutionDetail = cloneDeep(ErrorMoreDialogComponent.errorData);
    this.isMultipleErrorCode = this.checkIsMultipleError();
  }

  private checkIsMultipleError(){
    let allErrorCode = [];
    for(let detailIteam of this.detail){
        let messageWithError =  detailIteam['message'].split('|| errorSummary:');
        if(messageWithError.length && messageWithError[1]){
          let onlyErrorData = JSON.parse(messageWithError[1]);
          if(onlyErrorData['errorCode']){
            if(!allErrorCode.includes(onlyErrorData['errorCode'])){
              allErrorCode.push(onlyErrorData['errorCode']);
            }
          }
        }
    }
    if(allErrorCode.length === 1){
      return false;
    }else if(allErrorCode.length > 1){
      return true;
    }else{
      return false;
    }
  }
  
  constructor(
    public dialogService: DialogService,
    public http:HttpClient
    
  ) {
    super(dialogService);
  }
}
